export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 60,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_specBeginDate') || '投产日期',
    field: 'specBeginDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_specProductionDays') || '生产天数',
    field: 'specProductionDays',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
  },
  {
    title: that.$l('table_label_dailySpecQty') || '半成品日产能',
    field: 'dailySpecQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_batchSpecQty') || '批次总产能',
    field: 'batchSpecQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_batchUnitQty') || '批次总成套数量',
    field: 'batchUnitQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_specEndDate') || '完工日期',
    field: 'specEndDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_transit') || '运输天数',
    field: 'transitTimes',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitBeginDate') || '半成品到厂日期',
    field: 'unitBeginDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_packingPerDay') || '人天包装量',
    field: 'packingPerDay',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
  },
  {
    title: that.$l('table_label_packersPerDay') || '投入人数',
    field: 'packersPerDay',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
  },
  {
    title: that.$l('table_label_dailyPackingQty') || '日包装量',
    field: 'dailyPackingQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
  },
  {
    title: that.$l('table_label_packingDays') || '完工天数',
    field: 'packingDays',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitEndDate') || '完工日期',
    field: 'unitEndDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
  },
  {
    title: that.$l('table_label_unitInBoundQty') || '入库成品',
    field: 'unitInBoundQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitOutBoundQty') || '出库成品',
    field: 'unitOutBoundQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_unitInv') || '可用成品数量',
    field: 'unitInvQty',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
